module.exports = __webpack_public_path__ + "static/media/vf_wouter_core.73e1f3f9.svg";